import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createApprovalType,
  deleteApprovalType,
  getApprovalType,
  getApprovalTypes,
  getApprovalTypesMasterData,
  updateApprovalType
} from '../../../api/approval-types';

export const getApprovalTypesAsync = createAsyncThunk(
  'approvalTypes/getApprovalTypes',
  getApprovalTypes
);

export const getApprovalTypesMasterDataAsync = createAsyncThunk(
  'approvalTypes/getApprovalTypesMasterData',
  getApprovalTypesMasterData
);

export const getApprovalTypeAsync = createAsyncThunk(
  'approvalTypes/getApprovalType',
  getApprovalType
);

export const createApprovalTypeAsync = createAsyncThunk(
  'approvalTypes/createApprovalType',
  createApprovalType
);

export const updateApprovalTypeAsync = createAsyncThunk(
  'approvalTypes/updateApprovalType',
  updateApprovalType
);

export const deleteApprovalTypeAsync = createAsyncThunk(
  'approvalTypes/deleteApprovalType',
  deleteApprovalType
);

export interface ApprovalType {
  id: number;
  name: string;
}

interface ApprovalTypeState {
  data: ApprovalType[];
  masterData: ApprovalType[];
  count: number;
  selectedApprovalType: ApprovalType | null;
}

const initialState: ApprovalTypeState = {
  data: [],
  masterData: [],
  count: 0,
  selectedApprovalType: null
};

export default createSlice({
  name: 'approvalTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApprovalTypesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getApprovalTypesMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getApprovalTypeAsync.fulfilled, (state, action) => {
      state.selectedApprovalType = action.payload;
    });
  }
});
